// extracted by mini-css-extract-plugin
export default {"wrapper":"input-quantity_wrapper__ZVs2r","buttonWrapper":"input-quantity_buttonWrapper__sOBGU","disabled":"input-quantity_disabled__6ZN+U"};